import { useCallback, useState } from 'react';
import { latestBlockAtom, navigationPinAtom, setNavigationPin } from '../../atoms';
import { emitAtomEvent, useAtom } from '../../lib';
import { ButtonTertiary, Icon, Link, Logo, Typography } from '../shared';
import NavigationLinks from './NavigationLinks';

import './Navigation.scss';

const Navigation = () => {
  const [latestBlock] = useAtom(latestBlockAtom);
  const [navigationPin] = useAtom(navigationPinAtom);

  const [expanded, setExpanded] = useState(navigationPin);
  const [dataRefreshing, setDataRefreshing] = useState(false);

  const onExpand = useCallback(() => {
    if (navigationPin) {
      return;
    }

    setExpanded(true);
  }, [navigationPin]);

  const onCollapse = useCallback(() => {
    if (navigationPin) {
      return;
    }

    setExpanded(false);
  }, [navigationPin]);

  const onPinNavigation = useCallback(() => {
    setNavigationPin(!navigationPin);
  }, [navigationPin]);

  const onRefreshData = useCallback(() => {
    setDataRefreshing(true);

    emitAtomEvent('user-refresh').then(() => {
      setDataRefreshing(false);
    });
  }, []);

  return (
    <div
      className="nostra__navigation__container"
      onMouseEnter={onExpand}
      onMouseLeave={onCollapse}
      data-pinned={navigationPin}
    >
      <div className="nostra__navigation">
        {expanded && (
          <div className="nostra__navigation__pin" data-active={navigationPin}>
            <ButtonTertiary darkBg onClick={onPinNavigation}>
              {navigationPin ? (
                <Icon variant="pin-solid" size={16} color="--icon-default-darkbg" />
              ) : (
                <Icon variant="pin" size={16} color="--icon-default-darkbg" />
              )}
            </ButtonTertiary>
          </div>
        )}
        <div className="nostra__navigation__itemsContainer">
          <Logo type={expanded ? 'nostra-full-logo' : 'nostra-logo'} />
          <div className="nostra__navigation__links">
            <NavigationLinks expanded={expanded} />
          </div>
        </div>
        <div className="nostra__navigation__itemsContainer">
          <div className="nostra__navigation__socials">
            <Link href="https://discord.gg/zwa8K3drb" className="nostra__navigation__social">
              <Icon variant="discord" size={12} color="--icon-supporting" />
            </Link>
            <Link href="https://twitter.com/nostrafinance" className="nostra__navigation__social">
              <Icon variant="x" size={12} color="--icon-supporting" />
            </Link>
            <Link href="https://docs.nostra.finance/" className="nostra__navigation__social">
              <Icon variant="git-book" size={16} color="--icon-supporting" />
            </Link>
          </div>
          <div className="nostra__navigation__serviceStatus">
            <div className="nostra__navigation__serviceStatusIconContainer">
              <div className="nostra__navigation__serviceStatusIcon" />
            </div>
            {expanded && (
              <Typography variant="body-sm" color="text-supporting-darkbg">
                {latestBlock}
              </Typography>
            )}
          </div>
          <div className="nostra__navigation__refresh" onClick={onRefreshData}>
            <div className="nostra__navigation__refreshButton" data-refreshing={dataRefreshing}>
              <Icon variant="refresh" size={16} color="--icon-supporting" />
            </div>
            {expanded && (
              <Typography
                variant="body-sm"
                color="text-supporting-darkbg"
                className="nostra__navigation__refreshButtonLabel"
              >
                Refresh data
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Navigation;
